import React from 'react';

import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';

import {Messages} from 'commons/constants';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormDigitalizedSignature from './InnerFormDigitalizedSignature';
import {DigitalizedSignatureValues} from 'commons/models/modules/content/DigitalizedSignatureValues';

DigitalizedSignatureForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof DigitalizedSignatureForm.propTypes>,
    DigitalizedSignatureValues
>({
    mapPropsToValues: () => {
        return {
            signature: '',
            informationCheck: false,
        };
    },
    mapPropsToErrors: () => {
        return {
            signature: '',
            informationCheck: '',
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: DigitalizedSignatureValues) => {
        const errors: FormikErrors<DigitalizedSignatureValues> = {};
        if (!values.signature) {
            errors.signature = Messages.SIGNATURE_NOT_CAPTURED;
        }
        if (!values.informationCheck) {
            errors.informationCheck = Messages.ACCEPT_THE_TERMS;
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
})(InnerFormDigitalizedSignature);

function DigitalizedSignatureForm(
    props: InferPropTypes<typeof DigitalizedSignatureForm.propTypes>
) {
    const {submitHandler} = props;

    return (
        <div className='DigitalizedSignatureForm'>
            <FormControl submitHandler={submitHandler} />
        </div>
    );
}
export default DigitalizedSignatureForm;
